import type { JwtToken } from "@/functional/auth/parseJwt";

export default (jwtToken: JwtToken | null): boolean => {
  return jwtToken === null || jwtToken.exp < Date.now() / 1000;
};
